@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}

<ws-modal-wrapper headerLabel="Tax Feed Log Details"
                  cancelHelpContentId="app.cancel"
                  cancelClass="btn-primary"
                  [hideSave]="true"
                  (cancel)="cancel()">
    @if (taxFeedDiagnosticsDetail) {
        <div class="ws-flex-container-vertical ws-stretch">
            <div class="ws-flex-container-vertical ws-flex-auto">
                <label>Request Payload:</label>
                <textarea class="form-control" disabled style="width: 100%" rows="5" [(ngModel)]="taxFeedDiagnosticsDetail.requestPayloadJson"></textarea>
            </div>
            <div class="ws-flex-container-vertical ws-flex-auto">
                <label style="margin-top: 16px">Response Payload:</label>
                <textarea class="form-control" disabled style="width: 100%" rows="5" [(ngModel)]="taxFeedDiagnosticsDetail.responsePayloadJson"></textarea>
            </div>
            <div class="ws-flex-container-vertical ws-flex-auto">
                <label style="margin-top: 16px">Summary Ids:</label>
                <textarea class="form-control" disabled style="width: 100%" rows="2" [(ngModel)]="taxFeedDiagnosticsDetail.summaryIdsJson"></textarea>
            </div>
            <div class="ws-flex-container-vertical ws-flex-auto">
                <label style="margin-top: 16px">Logs:</label>
                <tax-feed-log-details-grid
                    [detailLogs]="taxFeedDiagnosticsDetail.detailLogs">
                </tax-feed-log-details-grid>
            </div>
        </div>
    }
</ws-modal-wrapper>
